export const TRANSLATION_KEYS_NAMESPACES = [
    'pospublic',
    'dineq',
];
